(() => {
  const init = root => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const gallery = root.querySelector('[data-gallery]');
    if (gallery) {
      const main = gallery.querySelector('[data-gallery-main]');
      const thumbs = [...gallery.querySelectorAll('[data-gallery-src]')];
      const count = gallery.querySelector('[data-gallery-count]');
      const stage = gallery.querySelector('.bk-gallery-stage');
      let index = 0;
      let touchStart = null;
      let suppressClick = false;
      const show = next => {
        index = (next + thumbs.length) % thumbs.length;
        main.src = thumbs[index].dataset.gallerySrc;
        main.alt = thumbs[index].dataset.galleryAlt;
        thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        count.textContent = `${index + 1} / ${thumbs.length}`;
      };
      thumbs.forEach((button, i) => button.addEventListener('click', () => show(i)));
      gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => show(index - 1));
      gallery.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
      gallery.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        show(index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      stage.addEventListener('touchstart', event => {
        suppressClick = false;
        const touch = event.touches.length === 1 ? event.touches[0] : null;
        touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
      }, { passive: true });
      stage.addEventListener('touchend', event => {
        if (!touchStart) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - touchStart.x;
        const dy = touch.clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          suppressClick = true;
          show(index + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
      stage.addEventListener('touchcancel', () => { touchStart = null; });
      stage.addEventListener('click', event => {
        if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; }
      }, true);
    }
    const videos = [...root.querySelectorAll('video')];
    videos.forEach(video => video.addEventListener('play', () => videos.forEach(other => {
      if (other !== video) other.pause();
    })));
  };
  document.querySelectorAll('[data-bk-viral]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-bk-viral]')));
})();
